import React from 'react'
import EPCLink from "../../../../component/Asset/EPCLink";
import {dayMonthYearAtTime, temUntil} from "../../../../utils/dates";

class AssetAlertGridTemplate {

  alert;

  constructor(alert) {
    this.alert = alert;
  }

  columns = [
    {
      Header: "EPC",
      accessor: "asset.epc.value",
      Cell: (props) => {
        const {asset} = props.original;
        return asset ? asset.tags.map(x => <p key={x.value}><EPCLink epc={x}/></p>) : "[]";
      }
    },
    {
      Header: "Refêrencia",
      accessor: "asset.productType.reference"
    },
    {
      Header: "Nome",
      accessor: "asset.productType.friendlyName"
    },
    {
      Header: "Local",
      accessor: "asset.currentState.lsd.bizLocation.friendlyName"
    },
    {
      Header: "Disposição",
      accessor: "asset.currentState.lsd.disposition.friendlyName"
    },
    {
      Header: "Etapa",
      accessor: "asset.currentState.lsd.bizStep.friendlyName"
    },
    {
      Header: "Data",
      accessor: "asset.currentState.stateDate",
      isDate: true,
      Cell: (props) => dayMonthYearAtTime(props.original.asset.currentState.stateDate)
    },
    {
      Header: "Tempo parado",
      accessor: "asset.currentState.stateDate",
      isDate: true,
      Cell: (props) => temUntil(props.original.asset.currentState.stateDate, this.alert.alertDate)
    }
  ];

  endpoint = () => `alerts/v1/alerts-details/alerts/${this.alert.id}/ALERT_PERMANENCE_ASSET`
}

export {AssetAlertGridTemplate}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/PermanenceAlert/AssetAlertGridTemplate.js